import type { CSSProperties } from 'react';
import {
  IS_BOLD,
  IS_ITALIC,
  IS_STRIKETHROUGH,
  IS_UNDERLINE,
} from '@payloadcms/richtext-lexical/lexical';

const hasFormat = (format: number, flag: number) => (format & flag) !== 0;

const getTextDecoration = (format: number) => {
  const decorations = [
    hasFormat(format, IS_UNDERLINE) && 'underline',
    hasFormat(format, IS_STRIKETHROUGH) && 'line-through',
  ].filter(Boolean);
  return decorations.length ? decorations.join(' ') : 'inherit';
};

export const formatToStyle = (format: number): CSSProperties => ({
  fontWeight: hasFormat(format, IS_BOLD) ? 'bold' : 'inherit',
  fontStyle: hasFormat(format, IS_ITALIC) ? 'italic' : 'inherit',
  textDecoration: getTextDecoration(format),
});
